import { I18n } from "i18n-js";
import translations from './translations.js';

const i18nInstance = new I18n;
i18nInstance.translations = translations;
window.I18n = i18nInstance;
// console.log(i18nInstance.t);
// console.log("Hello", i18nInstance);
export { i18nInstance };
